import React, { memo } from 'react'
import styled from 'styled-components'
import { Divider as PCLNDivider } from 'pcln-design-system'

const StyledDivider = styled(PCLNDivider)`
  z-index: 1;
`

function Divider() {
  return <StyledDivider borderColor='background.light' my={0} />
}

export default memo(Divider)
